/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    VolumeMiniReference,
    VolumeMiniReferenceFromJSON,
    VolumeMiniReferenceFromJSONTyped,
    VolumeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootMini
 */
export interface MediaRootMini {
    /**
     * 
     * @type {number}
     * @memberof MediaRootMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMini
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMini
     */
    readonly fullPath: string;
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootMini
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {VolumeMiniReference}
     * @memberof MediaRootMini
     */
    volume: VolumeMiniReference;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMini
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootMini
     */
    prefetchThumbnailStrips?: boolean;
}

export function MediaRootMiniFromJSON(json: any): MediaRootMini {
    return MediaRootMiniFromJSONTyped(json, false);
}

export function MediaRootMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'fullPath': json['full_path'],
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'volume': VolumeMiniReferenceFromJSON(json['volume']),
        'path': !exists(json, 'path') ? undefined : json['path'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
    };
}

export function MediaRootMiniToJSON(value?: MediaRootMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'volume': VolumeMiniReferenceToJSON(value.volume),
        'path': value.path,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
    };
}


